import React, { useCallback, useEffect, useState, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { useNavigate, useSearchParams } from "react-router-dom";
import styled from "styled-components";
import { Button } from "@vds/buttons";
import { Grid, Row, Col } from "@vds/grids";
import { Icon } from "@vds/icons";
//import { Pagination } from "@vds/pagination";
import { Pagination } from "@vds/core";
import { color } from "@vds-tokens/core";



import { Text } from '@vds/core';
import {
  setss7Domains,
  setGWDeviceType,
  setGWPlansID,
  setCurrentFlowForHPB,
  setCurrentActiveStep,
  setCreditFirstEntryPoint,
} from "../../../app/ducks/GlobalSlice";
import { useGlobalData } from "hooks";
import { MarginSpacerL, MarginSpacerM, MarginSpacerS } from "../styleTag";
import { validateZipcode, setIsPOYDFromGridwall } from "pages/Mobility/ducks/MobilitySlice";
import NewCustomerAddressModal from "common/components/Modals/NewCustomerAddressModal";
import { DeviceCard, PromoCard, GWJointOfferCard } from "../DeviceCard";
import "./Gridwall.css";
import PromoCardNew from "../DeviceCard/PromoCardNew";
import BuyNowCard from "../DeviceCard/BuyNowCard";
import POYDModal from "pages/Mobility/components/POYD/POYDModal";
import JointOfferCardNew from "../DeviceCard/JointOfferCardNew";
import  PromoCardPayOff from "../DeviceCard/PromoCardPayOff";

const Gridwall = React.memo(function Gridwall(props) {
  const { t } = useTranslation(["app", "gridwall"],{ useSuspense: false });
  const pageData = useSelector((state) => state.MobilityPage);
  const landing4gData = useSelector((state) => state.Landing4GPage);
  const callBackRef = useRef(null);
  const paramRef = useRef(null);
  const navigate = useNavigate();
  const { metaInformation, sessionCartData } = useGlobalData();
  const creditFirstEnabled = metaInformation?.enableCreditFirstFlow || false;
  const [showCreditFirst, setShowCreditFirst] = useState(false)
  const showBuyNowFlowNSE = metaInformation?.showBuyNowNSE;
  const showBuyNowFlowJointOffer = metaInformation?.showBuyNowJointOffer;
  const aem = t("gridwall", { ns: "gridwall", returnObjects: true });
  const aem1 = t("app", { ns: "app", returnObjects: true });
  const dispatch = useDispatch();
  const [pageSelected, handlePageSelected] = useState(1);
  const [pagenoclick, setPagenoclick] = useState("");
  const [vbcCardClicked,setVBCCardClicked] = useState(false);
  const globalData = useSelector((state) => state.GlobalData);
  const isfromAgentLinkPage = useSelector(
    (state) => state?.GlobalData?.fromAgentLinkDealsPage
  );
  const isfromMyLinkPage = useSelector(
    (state) => state?.GlobalData?.fromMyLinkDealsPage
  );
  const creditData = useSelector((state) => state.CreditFirstSlice)
  const [searchParams, setSearchParams] = useSearchParams();
  const paramsPlanId = searchParams.get("planId")?.match(/\d+/)[0];
  const [showNewCustomerModal, setShowNewCustomerModal] = useState(false);
  const [forDeviceCard, setForDeviceCard] = useState(false);
  const deviceCardClickedRef = useRef(forDeviceCard);
  const byodCardClickedRef = useRef(null);
  const [isSmartphClicked, SetIsSmartphclicked] = useState(false);
  const [isEnableVBC, setIsEnableVBC] = useState(false);
  const [isEligibleVBC, setIsEligibleVBC] = useState(
    globalData?.IsVBCEligible ? true : false
  );
  const [gotoVBCpage, setGotoVBCpage] = useState(false);
  const [showPoydModal, setShowPoydModal] = useState(false);
  const zipCodeFromLearn = useSelector((state) => {
    return (
      state.PlanFirst?.addressFromLearn?.zipCode ??
      state.PlanFirst?.addressFromLearn?.zipCodeVal
    );
  });
  const isEmailEnable = t("app.common.isEmailEnable", { ns: "app" });
  const isZipcodePresent =
    !!zipCodeFromLearn || pageData?.zipcodeFromGW || pageData?.zipCode;
  if (paramsPlanId) {
    dispatch(setGWPlansID(paramsPlanId));
  }
  const paramsDeviceType = searchParams.get("deviceType");
  const nseModalData = t("gridwall.buyNow_NseModal", {
    ns: "gridwall",
    returnObjects: true,
  });
  const joModalData = t("gridwall.buyNow_JOModal", {
    ns: "gridwall",
    returnObjects: true,
  });

  if (paramsDeviceType) {
    dispatch(setGWDeviceType(paramsDeviceType));
  }
  const onClickHandler = useCallback(
    (data, selectedSku) =>
      props.onClickHandler(item.seoUrlName, item.deviceId, selectedSku),
    []
  );

 let smartPhoneFilterApplied = false;
 let AllDeviceLocation = location && location.pathname && location.pathname.includes("/devices/all")

if (AllDeviceLocation) {
  const categoryList = pageData?.filterApplied?.categoryList;
  const isCategoryListValid = Array.isArray(categoryList);
  const hasSmartPhoneFilter = isCategoryListValid && categoryList.some(cat => cat?.key === "PDA/SmartPhones");
  const hasOtherFilters = isCategoryListValid && categoryList.some(cat => cat?.key !== "PDA/SmartPhones");

  if (!isCategoryListValid || categoryList.length === 0) {
    smartPhoneFilterApplied = true;
  }
  else if (hasSmartPhoneFilter && categoryList.length === 1) { // Added length check for 'only' smartphone filter
      smartPhoneFilterApplied = true;
  }
  else if (hasSmartPhoneFilter && hasOtherFilters) {
    smartPhoneFilterApplied = true;
  }
}


  const isPOYDFlow = pageData?.isPOYDFlow
  const showPOYD = aem?.POYD?.show;
  const isSmartPhonesGrid = location && location.pathname && location.pathname.includes("/devices/smartphones") ? true : false
  const isSmartPhoneAllDevices =  smartPhoneFilterApplied && AllDeviceLocation
  const showGWjointOfferCard =
    aem?.GWJointOffer?.showGWJointOfferCardFlag &&
    !pageData?.GWJointOfferSelected &&
    !props?.planFirstData &&
    !props?.mixedCartApplied &&
    (location?.pathname?.includes("/devices/all") ||
      location?.pathname?.includes("/devices/samsung") ||
      location?.pathname?.includes("/devices/smartphones/samsung") ||
      location?.pathname?.split("/").pop() === "smartphones" ||
      location?.pathname?.split("/").pop() === "") &&
    (props.brandFilter === "All" ||
      props.brandFilter === "Samsung" ||
      props.brandFilter === "");

  const showPopularDevice = aem?.popularDevice?.showGWPopularDeviceFlag;
  const showNseLTEDevice = aem?.nseLTEDevice?.showGWPopularDeviceJOFlag;

  const showBuyNowNSE = showBuyNowFlowNSE && !!aem?.buyNowCard?.enable;

  useEffect(() => {
    if(sessionCartData?.apiResponse?.prospectFlowData?.creditFirstFlowStatus !== 'COMPLETED' && sessionCartData?.apiResponse?.prospectFlowData?.creditFirstFlowStatus !== 'DISABLED' && sessionCartData?.apiResponse?.prospectFlowData?.creditFirstFlowStatus !== 'FAILED') {
      setShowCreditFirst(true)
    }
  }, [sessionCartData])
  
  useEffect(() => {
    try {
      if (
        typeof window["lpTag"] != "undefined" &&
        lpTag?.section &&
        window?.lpTag?.newPage
      ) {
        lpTag.section = manipulateLpTagSections();
        setTimeout(() => {
          window?.lpTag?.newPage(window?.location?.href, {
            section: lpTag.section,
          });
        }, 8000);
      }
    } catch (e) {
      console.error(e);
    }
  }, []);

  useEffect(() => {
    if (window?.mbtGlobal?.flags?.ENABLE_VBC_PROSPECT === "Y") {
      let zip =
        zipCodeFromLearn || pageData?.zipcodeFromGW || pageData?.zipCode;
      if ((zip && isValidDAASZipcode) || !zip) setIsEnableVBC(true);
    } else {
      setIsEnableVBC(false);
    }
    if (
      globalData?.IsVBCClearCartClicked ||
      globalData?.IsVBCEligible === false
    ) {
      setIsEligibleVBC(false);
    }
    dispatch(setss7Domains(aem1?.common?.ss7Domains));
  }, []);

  const showAddressModalAgentLink = aem?.enableAddressModalAgentLink;
  const movePDPAddressModaltoGW =
    isfromAgentLinkPage || isfromMyLinkPage ? showAddressModalAgentLink : true;
  let isSmartPhones = props?.gridData?.some((arr) =>
    arr.category?.includes("PDA/SmartPhones")
  );
  let isTablets = props?.gridData[0]?.category?.includes("Tablets");
  let isBasicPhones = props?.gridData[0]?.category?.includes("Phones");
  let isMobileHotspots = props?.gridData[0]?.category?.includes(
    "BroadbandAccess Devices"
  );
  let isOneTalk = props?.gridData[0]?.category?.includes("Connected Devices");
  let isLaptops = props?.gridData?.some((arr) =>
    arr.category?.includes("Connected Laptops")
  );
  let isSmartWatches = isSmartPhones
    ? false
    : props?.gridData[0]?.category?.includes("Smart Watches") ||
      props?.gridData[0]?.category?.includes("Connected Smartwatches");

  if (pageData?.filterApplied?.categoryList) {
    pageData?.filterApplied?.categoryList?.find((cat) => {
      if (cat?.name == "Connected Laptops") {
        isLaptops = true;
      } else if (cat?.name == "PDA/SmartPhones") {
        isSmartPhones = true;
      }
    });
  }

  const getGridwallCards = (selectedPage, isBogo) => {
    let cards = props.gridData.map((item) => (
      <Col key={item.seoUrlName} className="product-box-wrap one-talk-product">
        <DeviceCard
          key={item.deviceId}
          data={item}
          aemContent={props.aemContent}
          tradeInToggle={props?.tradeInToggle}
          onClickHandler={props.onClickHandler}
          showDPP={props.showDPP}
          sortBy={props.sortBy}
          onCompareSelect={props.onCompareSelect}
          isSelected={props.selectedCompare.includes(item.deviceId)}
          hidePromoBadge={props.hidePromoBadges}
          ss7Domains={props.ss7Domains}
          isBogo={isBogo || false}
          setForDeviceCard={(e) => setForDeviceCard(e)}
          setShowNewCustomerModal={(e) => setShowNewCustomerModal(e)}
          onChangeRef={onChangeRef}
          zipCode={pageData?.zipCode}
          // continueToPDP={continueToPDP}
        />
      </Col>
    ));

    if (showBuyNowNSE && isSmartPhones && !isPOYDFlow) {
      const buyNowPosition = aem?.buyNowCard?.position || 1;
      const buyNowCard = (
        <Col key="buy-now-card" className="product-box-wrap">
          <BuyNowCard aem={aem?.buyNowCard} />
        </Col>
      );
      if (buyNowPosition === 1) {
        cards = [buyNowCard, ...cards];
      } else {
        if (cards.length > buyNowPosition) {
          cards.splice(buyNowPosition, 0, buyNowCard);
        }
      }
    }    

    let enableSmartWatch = isEnableVBC && isSmartWatches;
    if (!props?.isBogo && !landing4gData?.showHeroCopyForBundle) {
      if (
        (props?.byodCard && enableSmartWatch) ||
        (props?.byodCard &&
          (isLaptops ||
            isMobileHotspots ||
            isSmartPhones ||
            isTablets ||
            (isLaptops && isSmartWatches)))
      ) {
        let byodcardplacement = !props?.hotspotPromo
          ? cards.slice(0, props?.byodCard?.position - 1)
          : cards.slice(0, props?.byodCard?.position - 1);
        let byodcardplacementalign = !props?.hotspotPromo
          ? cards.slice(props?.byodCard?.position - 1)
          : cards.slice(props?.byodCard?.position - 1);
        {!isPOYDFlow && !(globalData?.fromAgentLinkDealsPage && globalData?.agentLinkFlowType === "hotspotDevices") ? 
        cards = [
          ...byodcardplacement,
          <Col
            key="byod"
            className={`product-box-wrap ${
              isEnableVBC ? "product-box-vbc" : ""
            }`}
          >
            {isEnableVBC ? (
              <PromoCard
                aemContent={
                  isSmartPhones
                    ? aem?.byodVBC?.smartPhoneVBC
                    : isLaptops
                    ? aem?.byodVBC?.laptops
                    : isTablets
                    ? aem?.byodVBC?.tablet
                    : isBasicPhones
                    ? aem?.byodVBC?.basicPhone
                    : isMobileHotspots
                    ? aem?.byodVBC?.hotspot
                    : isSmartWatches
                    ? aem?.byodVBC?.smartwatch
                    : aem["non-smartPhone"]
                }
                type={
                  isSmartPhones
                    ? "smartPhone"
                    : isLaptops
                    ? "laptops"
                    : isTablets
                    ? "tablet"
                    : isMobileHotspots
                    ? "hotspot"
                    : isBasicPhones
                    ? "basicPhone"
                    : isSmartWatches
                    ? "smartwatch"
                    : "non-smartPhone"
                }
                category={props?.gridData[0]?.category}
                isEnableVBC={isEnableVBC}
                aemcontentVBC={aem?.byodVBC?.VBC}
                isVBClicked={continueToDaasPge}
                eligibleVBC={isEligibleVBC}
                setForDeviceCard={(e) => setForDeviceCard(e)}
                setShowNewCustomerModal={(e) => setShowNewCustomerModal(e)}
                onChangeRefFromByodCard={(e, URL) =>
                  onChangeRefFromByodCard(e, URL)
                }
              />
            ) : (
              <PromoCard
                aemContent={
                  isSmartPhones
                    ? aem?.byod?.smartPhone
                    : isLaptops
                    ? aem?.byod?.laptops
                    : isTablets
                    ? aem?.byod?.tablet
                    : isBasicPhones
                    ? aem?.byod?.basicPhone
                    : isMobileHotspots
                    ? aem?.byod?.hotspot
                    : aem["non-smartPhone"]
                }
                type={
                  isSmartPhones
                    ? "smartPhone"
                    : isLaptops
                    ? "laptops"
                    : isTablets
                    ? "tablet"
                    : isMobileHotspots
                    ? "hotspot"
                    : isBasicPhones
                    ? "basicPhone"
                    : "non-smartPhone"
                }
                category={props?.gridData[0]?.category}
                isEnableVBC={isEnableVBC}
                isVBClicked={continueToDaasPge}
                setForDeviceCard={(e) => setForDeviceCard(e)}
                setShowNewCustomerModal={(e) => setShowNewCustomerModal(e)}
                onChangeRefFromByodCard={(e, URL) =>
                  onChangeRefFromByodCard(e, URL)
                }
              />
            )}
          </Col>,
          ...byodcardplacementalign,
        ] : 
        cards = [
          ...byodcardplacement,          
          ...byodcardplacementalign,
        ]
      }        
      }    

      if(!isPOYDFlow && ((isSmartPhonesGrid && aem?.PromoCardPayOff?.isJOFlag) || (isSmartPhoneAllDevices && aem?.PromoCardPayOff?.isJOFlag))){
        cards = [
          ...cards.slice(0, aem?.PromoCardPayOff?.position - 1),
          <Col key="poyd" className="product-box-wrap one-talk-product">
            <PromoCardPayOff aemContent={aem?.PromoCardPayOff} onClick={() => setShowPoydModal(true)} />
            <JointOfferCardNew
              aemContent={
                isSmartPhones ? aem?.JointOfferNew?.smartPhone : "non-smartPhone"
              }
              // category={props?.gridData[0]?.category}
              aemContentModal={aem?.JointOfferNew?.JointOfferNewModalContent}
            />
          </Col>,
          ...cards.slice(aem?.PromoCardPayOff?.position - 1),
        ];
      }

      if (!isPOYDFlow && showPOYD && !(globalData?.fromAgentLinkDealsPage && globalData?.agentLinkFlowType === "hotspotDevices")) {
        cards = [
          ...cards.slice(0, aem?.POYD?.position - 1),
          <Col key="poyd" className="product-box-wrap one-talk-product">
            <PromoCardNew
              aemContent={aem?.POYD}
              useAlternateCta={true} // replace with logic to enable/disable POYD flow
              onClick={() => {
                if(window.mbtGlobal.flags.ENABLE_POYD_DIGITAL === "Y"){
                  setShowPoydModal(true)
                }
              }}
            />
          </Col>,
          ...cards.slice(aem?.POYD?.position - 1),
        ];
      }

      if (!isPOYDFlow && props?.GWJointOfferCard && isSmartPhones && showGWjointOfferCard) {
        let GWJointOfferCardplacement = !props?.hotspotPromo
          ? cards.slice(0, props?.GWJointOfferCard?.position - 1)
          : cards.slice(0, props?.GWJointOfferCard?.position - 1);
        let GWJointOfferCardplacementalign = !props?.hotspotPromo
          ? cards.slice(props?.GWJointOfferCard?.position - 1)
          : cards.slice(props?.GWJointOfferCard?.position - 1);
        cards = [
          ...GWJointOfferCardplacement,
          <Col key="byod" className="product-box-wrap gridwall-joint-offer">
            <GWJointOfferCard
              aemContent={
                isSmartPhones ? aem?.GWJointOffer?.smartPhone : "non-smartPhone"
              }
              category={props?.gridData[0]?.category}
              aemContentModal={aem?.GWJointOffer?.GWJointOfferModalContent}
            />
          </Col>,
          ...GWJointOfferCardplacementalign,
        ];
      }

      // TODO: clean up old buy now implementation
      // if (isSmartPhones && showBuyNowFlowNSE) {
      //   cards = [
      //     ...cards.slice(0, 2),
      //     <Col key="popular-device">
      //       <PromoCard
      //         aemContent={aem?.popularDevice}
      //         aem={aem}
      //         type="popularDevice"
      //         isDeviceClicked={() => {
      //           if (
      //             props?.onClickHandlerPopularDevice &&
      //             typeof props?.onClickHandlerPopularDevice == "function"
      //           )
      //             props?.onClickHandlerPopularDevice();
      //         }}
      //         isQuickCartDevice={showPopularDevice}
      //         fromBuyNowFlow
      //         fromBuyNowFlowNse={showBuyNowFlowNSE}
      //         detailsNseModalAem={nseModalData}
      //       />
      //     </Col>,
      //     ...cards.slice(2),
      //   ];
      // }
      // if (isSmartPhones && showBuyNowFlowJointOffer) {
      //   cards = [
      //     ...cards.slice(0, 8),
      //     <Col key="nse-LTE-device">
      //       <PromoCard
      //         aemContent={aem?.nseLTEDevice}
      //         aem={aem}
      //         type="popularDevice"
      //         isQuickCartDevice={showNseLTEDevice}
      //         isDeviceClicked={() => {
      //           if (
      //             props?.onClickHandlerLTEDevice &&
      //             typeof props?.onClickHandlerLTEDevice == "function"
      //           )
      //             props?.onClickHandlerLTEDevice();
      //         }}
      //         fromBuyNowFlow
      //         fromBuyNowFlowJointOffer={showBuyNowFlowJointOffer}
      //         detailsJOModalAem={joModalData}
      //       />
      //     </Col>,
      //     ...cards.slice(8),
      //   ];
      // }
      if (!isPOYDFlow && props?.hotspotPromo) {
        {!(globalData?.fromAgentLinkDealsPage && globalData?.agentLinkFlowType === "hotspotDevices") ? 
          cards = [
            ...cards.slice(0, 3),
            <Col key="hotspot-promo">
              <PromoCard
                aemContent={aem?.hotspot}
                aem={aem}
                type="hotspot"
                isEnableVBC={isEnableVBC}
                isVBClicked={continueToDaasPge}
              />
            </Col>,
            ...cards.slice(3),
          ]
         : 
          cards = [
            ...cards
          ]      
        }
      } else if (!isPOYDFlow && props?.laptopPromo) {
        cards = [
          ...cards.slice(0, aem?.connectedLaptops?.position?.laptops),
          <Col key="hotspot-promo">
            {isEnableVBC ? (
              <PromoCard
                aemContent={aem?.connectedLaptopsVBC}
                aem={aem}
                type="connectedLaptops"
                isEnableVBC={isEnableVBC}
                aemcontentVBC={aem?.VBC}
                isVBClicked={continueToDaasPge}
                eligibleVBC={isEligibleVBC}
              />
            ) : (
              <PromoCard
                aemContent={aem?.connectedLaptops}
                aem={aem}
                type="connectedLaptops"
                isEnableVBC={isEnableVBC}
                isVBClicked={continueToDaasPge}
                eligibleVBC={isEligibleVBC}
              />
            )}
          </Col>,
          ...cards.slice(aem?.connectedLaptops?.position?.laptops),
        ];
      } else if (
        props?.hasMore &&
        !isSmartWatches &&
        !isOneTalk &&
        !isSmartPhones &&
        !isTablets
      ) {
        let displayPromoCard = true;
        if (
          props.selectedCategory !== null &&
          props.selectedCategory &&
          props.selectedCategory.length
        ) {
          displayPromoCard = props.selectedCategory.filter(
            (data) =>
              String(data.name).toLowerCase().includes("watches") ||
              String(data.name).toLowerCase().includes("broadband")
          ).length
            ? false
            : true;
        }
        if (!isPOYDFlow && displayPromoCard) {
          const place =
            props.gridData.length > 2
              ? isEnableVBC
                ? props?.byodCard?.position
                : props?.byodCard?.position - 1
              : props.gridData.length;
          const placeVBC =
            props.gridData.length > 2
              ? isBasicPhones
                ? props?.byodCard?.position - 1
                : props?.byodCard?.position
              : props.gridData.length;
          cards = [
            ...cards.slice(0, isEnableVBC ? placeVBC : place),
            <Col key={"smartphone-promo" + place}>
              {isEnableVBC ? (
                <PromoCard
                  aemContent={
                    isSmartPhones
                      ? aem?.smartPhoneVBC
                      : isTablets
                      ? aem?.tablet
                      : isBasicPhones
                      ? aem?.basicPhoneVBC
                      : isMobileHotspots
                      ? aem?.hotspot
                      : isLaptops
                      ? aem?.connectedLaptops
                      : aem["non-smartPhone"]
                  }
                  type={
                    isSmartPhones
                      ? "smartPhone"
                      : isTablets
                      ? "tablet"
                      : isBasicPhones
                      ? "basicPhone"
                      : "non-smartPhone"
                  }
                  category={props?.gridData[0]?.category}
                  isEnableVBC={isEnableVBC}
                  aemcontentVBC={aem?.VBC}
                  isVBClicked={continueToDaasPge}
                  setForDeviceCard={(e) => setForDeviceCard(e)}
                  setShowNewCustomerModal={(e) => setShowNewCustomerModal(e)}
                  onChangeRefFromByodCard={(e, URL) =>
                    onChangeRefFromByodCard(e, URL)
                  }
                  eligibleVBC={isEligibleVBC}
                />
              ) : (
                <PromoCard
                  aemContent={
                    isSmartPhones
                      ? aem?.smartPhone
                      : isTablets
                      ? aem?.tablet
                      : isBasicPhones
                      ? aem?.basicPhone
                      : isMobileHotspots
                      ? aem?.hotspot
                      : isLaptops
                      ? aem?.connectedLaptops
                      : aem["non-smartPhone"]
                  }
                  type={
                    isSmartPhones
                      ? "smartPhone"
                      : isTablets
                      ? "tablet"
                      : isBasicPhones
                      ? "basicPhone"
                      : "non-smartPhone"
                  }
                  category={props?.gridData[0]?.category}
                  isEnableVBC={isEnableVBC}
                  isVBClicked={continueToDaasPge}
                  setForDeviceCard={(e) => setForDeviceCard(e)}
                  setShowNewCustomerModal={(e) => setShowNewCustomerModal(e)}
                  onChangeRefFromByodCard={(e, URL) =>
                    onChangeRefFromByodCard(e, URL)
                  }
                />
              )}
            </Col>,
            ...cards.slice(isEnableVBC ? placeVBC : place),
          ];
        }
      }
    }
    return cards;
  };
  const isValidDAASZipcode = useSelector(
    (state) => state.MobilityPage?.validZipcodeDaas
  );

  useEffect(() => {
    if (gotoVBCpage) {
      dispatch(setCurrentFlowForHPB(""));
      dispatch(setCurrentActiveStep(0));
      navigate("/shop/products/devices/smartphones/verizonbusinesscomplete");
      setGotoVBCpage(false);
    }
  }, [gotoVBCpage]);

  const handlePageSelection = (e) => {
    setPagenoclick(Math.random());
    props.loadFunc(e);
  };
  const continueToDaasPge = () => {
    if (isZipcodePresent) {
      setGotoVBCpage(true);
      dispatch(
        validateZipcode({
          zipcode: isZipcodePresent,
          isEmailEnable: isEmailEnable,
          isDaasZipCode: true,
        })
      );
    } else {
      setVBCCardClicked(true); 
      setShowNewCustomerModal(true);
    }
  };

  const onChangeRef = (check, onCardSelectwithAddress, e) => {
    deviceCardClickedRef.current = check;
    callBackRef.current = onCardSelectwithAddress;
    paramRef.current = e;
  };
  const onChangeRefFromByodCard = (check, URL) => {
    deviceCardClickedRef.current = check;
    byodCardClickedRef.current = URL;
  };
  useEffect(() => {
    if (showNewCustomerModal === false) {
      deviceCardClickedRef.current = false;
      byodCardClickedRef.current = "";
      setForDeviceCard(false);
    }
  }, [showNewCustomerModal]);

  const newCustomerBtnClicked = () => {
    setShowNewCustomerModal(false);
    if (callBackRef.current && paramRef.current) {
      callBackRef.current(paramRef.current);
    }
  };

  const isSmartPhonecliked = () => {
    SetIsSmartphclicked(true);
  };

  useEffect(() => {
    if (isSmartphClicked === true) {
      setIsEligibleVBC(false);
      setShowNewCustomerModal(false);
    }
  }, [isSmartphClicked]);

  const existingCustomerBtnClicked = () => {
    let redirectUrl = `${t("pdpDeepLinkUrl", { ns: "app" })}`;
    window.location.href = redirectUrl;
  };

  const handleCreditFirstNavigation = () => {
    dispatch(setCreditFirstEntryPoint('NSE'))
    navigate("/shop/credit-first")
  }

  return (
    <>
      {creditFirstEnabled && showCreditFirst && (
        <>
          <MarginSpacerM />
          <div className="credit-first-entry-container">
            <div className="credit-first-icon-container">
              <Icon name="wallet" size="XLarge" color="#EE0000" />
            </div>
            <div className="credit-first-text-button-container">
              <Text kind="title" size="small" bold={true}>
                {aem?.entryPointTitle}
              </Text>
              <Button
                size="small"
                use="secondary"
                onClick={handleCreditFirstNavigation}
                width="fit-content"
              >
                {aem?.entryPointSubtitle}
              </Button>
            </div>
          </div>
        </>
      )}
      <CustomGridWallContainer className="gridwall-container-text-highlight">
        <Grid colSizes={{ mobile: 2, tablet: 6, desktop: 4 }}>
          <CustomRow>
            {props?.gridData?.length ? (
              getGridwallCards(pageSelected, props?.isBogo)
            ) : props.loadEmptyDataContainer ? (
              <div>
                <Text kind="title" size="medium" bold={false}>
                  {aem?.no_results}
                </Text>
                <MarginSpacerS />
                <Text kind="body" size="large">{aem?.clear_filter}</Text>
                <MarginSpacerL />
                <Button
                  size="medium"
                  disabled={false}
                  use="secondary"
                  onClick={() => {
                    props.onClearFilter();
                  }}
                >
                  {aem?.labels?.clearAllFilters}
                  {/* //Clear all test */}
                </Button>
              </div>
            ) : (
              <></>
            )}
          </CustomRow>
        </Grid>
      </CustomGridWallContainer>
      {(showNewCustomerModal && !deviceCardClickedRef?.current) ||
      (showNewCustomerModal &&
        !!movePDPAddressModaltoGW &&
        deviceCardClickedRef?.current) ? (
        <NewCustomerAddressModal
          closeBtnClick={setShowNewCustomerModal}
          isVBC={isSmartPhonecliked}
          existingCustomerBtnClicked={existingCustomerBtnClicked}
          vbcCardClicked={vbcCardClicked}
          newCustomerBtnClicked={newCustomerBtnClicked}
          showNewCustomerModal={showNewCustomerModal}
          fromGridWall={false}
          forDeviceCard={deviceCardClickedRef?.current}
          forByodCardURL={byodCardClickedRef?.current}
          forVBCURL = {aem?.VBC?.navigateUrl}
          setForDeviceCard={setForDeviceCard}
        />
      ) : (
        <span />
      )}

      {props.totalResults > aem.defaultPageInfo.wireless.pageSize && (
        <div style={{ display: "flex", flexDirection: "row-reverse" }}>
          <CustomPagination
            kind="expanded"
            onSelectPage={(e) => {
              handlePageSelected(e);
              handlePageSelection(e);
            }}
            selectedPage={Number(props.pageNumClicked)}
            total={Math.ceil(
              props.totalResults / aem.defaultPageInfo.wireless.pageSize
            )}
            showArrow={true}
          />
        </div>
      )}
      <POYDModal 
        opened={showPoydModal} 
        onOpenedChange={setShowPoydModal} 
        onConfirm={() => {
          dispatch(setIsPOYDFromGridwall(true));
          navigate("/shop/products/devices/smartphones");
        }}  
      />
    </>
  );
});

const CustomRow = styled(Row)`
  @media (max-width: 545px) {
    padding: 0px !important;
    margin: 0px !important;
  }
`;

const CustomGridWallContainer = styled.div`
  div > {
    margin: auto !important;
  }
  background-color: ${color.stone};
  padding-bottom: 1rem;
  @media (min-width: 767px) and (max-width: 990px) {
    [class^=StyledRow-VDS]{
     position: relative;
     right: 10px
    }
`;

const CustomPagination = styled(Pagination)`
  margin-left: auto;
  margin-right: -6px;
  @media screen and (min-width: 230px) and (max-width: 767px) {
    margin-left: -1rem;
    margin-right: -5rem;
    margin-top: 1rem;
    position: relative;
  }
`;

export default Gridwall;
